export const RiskExposureCalculatorNameFields = {
	monthlyVolume: "monthly_volume",
	doYouOfferAProductServiceWarrantyOrGuarantee:
		"do_you_offer_a_product_service_warranty_or_guarantee",
	refundRatio: "refund_ratio",
	chargebackRatio: "chargeback_ratio",
	daysBeforeDiscountOrFeesAreCollected:
		"days_before_discount_or_fees_are_collected",
	estimatedPercentFees: "estimated_percent_fees",
	totalRiskExposure: "total_risk_exposure",
	assigneeId: "assignee_id",
	creditAndCbRiskExposure: "credit_and_cb_risk_exposure",
	dailyAverageMonthlySalesVolume: "daily_average_monthly_sales_volume",
	delayedDeliveryRiskExposure: "delayed_delivery_risk_exposure",
	discountAndFeeExposure: "discount_and_fee_exposure",
	id: "id",
	previous120DaysMonthlyVolume: "previous_120_days_monthly_volume",
};
